module.exports = __webpack_public_path__ + "static/media/connect-marker.78c543fd.svg";